module.exports = __webpack_public_path__ + "img/img4.c5696072.png";